import { AppRemixIcon } from '@/layout/AppComponents';
import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

const ModuleBridgeFolderDefaultWidget = (props) => (
  <DefaultWidgetTemplate
    module={props.module}
    route="user_module_moduleBridgeFolder_home"
    icon={<AppRemixIcon icon="folders" />}
  />
);

export default ModuleBridgeFolderDefaultWidget;
